module.exports = Object.freeze({
    SERVER_IP: 'nodebook.io',
    RENDER_LOGS: process.env.REACT_APP_RENDER_LOGS,
    WEBSITE_TITLE: 'Nodebook',
    API_SOCIAL: 'nodebook.io/api',
    Activity: {
        // pages
        PAGE_VISIT: 0,
        WEBSITE_LEAVE: 1,

        // sign up
        SIGN_UP: 2,
        SIGN_UP_TWITTER: 3,
        SIGN_UP_GOOGLE: 4,

        // login/logout
        LOGIN: 5,
        LOGIN_TWITTER: 6,
        LOGIN_GOOGLE: 7,
        LOGOUT: 8,

        // social
        PROFILE_UPDATE: 9,
        GROUP_CREATE: 10,
        GROUP_UPDATE: 11,
        GROUP_PERMS_UPDATE: 12,
        GROUP_DELETE: 13,
        GROUP_FOLLOW: 14,
        GROUP_UNFOLLOW: 15,
        USER_FOLLOW: 16,
        USER_UNFOLLOW: 17,
        NDBK_FOLLOW: 18,
        NDBK_UNFOLLOW: 19,
        NDBK_UPVOTE: 20,
        NDBK_DOWNVOTE: 21,
        COMMENTED: 22,

        // nodebook
        NDBK_CREATE: 23,
        NDBK_UPDATE: 24,
        NDBK_PERMS_UPDATE: 25,
        NDBK_DELETE: 26,
        NODE_CREATE: 27,
        NODE_UPDATE: 28,
        NODE_DELETE: 29,
        LINK_CREATE: 30,
        LINK_UPDATE: 31,
        LINK_DELETE: 32,
        NDBK_SEARCH: 33,
    },
});



// WEBPACK FOOTER //
// ./src/ndbk-constants.js